<template>
    <modal-wrapper modalClass="modal--small" :modalName="name">
        <div class="modal__header">
            <h3>Cookies</h3>
        </div>
        <div class="modal__content">
            This website uses cookies to improve the user experience.
        </div>
        <div class="modal__footer">
            <button class="button--cta" type="submit" @click="confirm">I understand</button>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import ModalWrapper from '@/components/general/ModalWrapper';

    //TODO style the cookie modal
    @Component
    export default class CookieModal extends Vue {
        name = 'cookie-modal';

        confirm() {
            this.$emit('confirm');
            this.$modal.hide(this.name);
        }
    }

    Vue.component('cookie-modal', CookieModal);
</script>



// WEBPACK FOOTER //
// src/components/cookies/CookieModal.vue